import * as React from 'react';
export const IcHubmode = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.5 12a1.45 1.45 0 00-.89.3L16 11.78a4 4 0 00-1.19-2.64L16 7a2 2 0 10-1.73-1l-1.22 2.16A3.71 3.71 0 0012 8a3.9 3.9 0 00-1.73.41L8 5.7a1.36 1.36 0 000-.2A1.5 1.5 0 106.46 7l2.28 2.69A4 4 0 008 12c.005.201.025.402.06.6l-1.87.8A2 2 0 005 13a2 2 0 102 2.24l1.87-.8A4 4 0 0012 16h.1l.46 1.62A2 2 0 0012 19a2 2 0 004 0 2 2 0 00-1.51-1.93L14 15.43a4 4 0 001.57-1.69l2.62.52A1.5 1.5 0 1019.5 12z'
      fill='currentColor'
    />
  </svg>
);
